import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialityQuestionsApi } from "@api/services";

const allowedRoles = [UserRole.Manager, UserRole.Owner];
const ACTION_GET_QUESTIONS = "GET_QUESTIONS";

const deleteQuestionFn = async (id: string): Promise<void> => {
  await doubleMaterialityQuestionsApi.doubleMaterialityQuestionsControllerDeleteQuestion(
    id,
  );
};

export const useDeleteQuestion = (
  user: UserProfileDto | null,
): {
  deleteQuestion: (id: string) => void;
  deleteQuestionAsync: (id: string) => Promise<unknown>;
  isPendingDeleteQuestion: boolean;
  isSuccessDeleteQuestion: boolean;
  deleteQuestionEnabled: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: enabled ? deleteQuestionFn : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_QUESTIONS],
      });
    },
  });

  return {
    deleteQuestion: (id) => mutation.mutate(id),
    deleteQuestionAsync: (id) => mutation.mutateAsync(id) as Promise<void>,
    isPendingDeleteQuestion: mutation.isPending,
    isSuccessDeleteQuestion: mutation.isSuccess,
    deleteQuestionEnabled: enabled,
  };
};
